import {useMemo} from "react";

import {BACKEND_APIS, USER_ROLES} from "@constants";
import {useUserApp} from "@hooks";


export default function useSkuDetailsRoleConfig() {
	const { userRole } = useUserApp()

	const urlApiPricing = useMemo(() => ({
		[USER_ROLES.STANDARD]: '/pricing',
		[USER_ROLES.MARKETPLACES]: '/pricing',
		[USER_ROLES.RETAILER]: '/pricing-retailers',
	})[userRole], [userRole])

	const urlApiPricingEvolution = useMemo(() => ({
		[USER_ROLES.STANDARD]: '/pricing-evolution',
		[USER_ROLES.MARKETPLACES]: '/pricing-evolution',
		[USER_ROLES.RETAILER]: '/pricing-retailers-evolution',
	})[userRole], [userRole])

	return {
		userRole,
		urlApiPricing: `${BACKEND_APIS.SKU_DETAILS}${urlApiPricing}`,
		urlApiPricingEvolution: `${BACKEND_APIS.SKU_DETAILS}${urlApiPricingEvolution}`,
		isRetailerUser: userRole === USER_ROLES.RETAILER,
		isStandardUser: userRole === USER_ROLES.STANDARD
	}
}